import React, { useEffect, useState } from "react";
import { Card, CardBody } from "../../../../../_metronic/_partials/controls";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../_redux/adminDashboard/adminDashboardActions";
import UnknownEmailSenderTable from "./UnknownEmailSenderTable";
import { AdminDashboardUIProvider } from "./AdminDashboardUIContext";
import { UnknownEmailSenderFilter } from "./UnknownEmailSenderFilter";
export default function UnknownEmailSender() {
  const { adminDashboard } = useSelector((state) => state, shallowEqual);

  const { newAccounts, totalAccounts } = adminDashboard;

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.fetchAccountsStatistics());
  }, []);

  return (
    <AdminDashboardUIProvider>
      <Card>
        <CardBody>
          new accounts in last 30 days {newAccounts} / {totalAccounts}
        </CardBody>
      </Card>
      <Card>
        <CardBody>
          <UnknownEmailSenderFilter />
          <UnknownEmailSenderTable />
        </CardBody>
      </Card>
    </AdminDashboardUIProvider>
  );
}
